import React from "react";
import { NavLink } from "react-router-dom";

const NavbarS = () => {
  return (
    <nav
      className="md:hidden flex fixed z-10 w-full"
      style={{ backgroundColor: "#111" }}
    >
      <ul className="w-full flex">
        <NavLink
          to="/"
          className="w-full block py-5 text-center text-lg border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50  transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
          exact
        >
          Home
        </NavLink>
        <NavLink
          to="/skills"
          className="w-full block py-5 text-center text-lg border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Skills
        </NavLink>
        <NavLink
          to="/projects"
          className="w-full block py-5 text-center text-lg border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Projects
        </NavLink>
        <NavLink
          to="/contact"
          className="w-full block py-5 text-center text-lg border-b border-l  border-yellow-200 border-opacity-0 hover:border-opacity-50 transition-all duration-150"
          activeClassName="text-black bg-yellow-300"
        >
          Contact
        </NavLink>
      </ul>
    </nav>
  );
};

export default NavbarS;
